export const formatPrice = (price: number): string => {
  return `${price.toLocaleString("sv-SE")} kr`;
};
